import { usePaletteTheme } from "../../context/paletteTheme"
import { Tooltip, TooltipWithBounds, defaultStyles, useTooltipInPortal } from "@visx/tooltip"
import { Divider } from '@mui/material'
import { getDate, getValue } from './graphUtils'
import styles from './Graph.module.css'

const bottomTooltipStyles = {
  ...defaultStyles,
  minWidth: 72,
  textAlign: "center",
  transform: "translateX(-50%)",
}

const tooltipThreshold = 150

const groupTooltipRecords = (records, threshold) => {
  if (!records) return undefined
  return records
    .sort((a,b) => (getDate(a)) - (getDate(b) || a.i - b.i))
    .reduce((acc, record) => {
      if (record.left - threshold > acc.left) {
        acc.grouped.push([record])
        acc.left = record.left
      } else {
        acc.grouped[acc.grouped.length - 1]?.push(record)
      }
      return acc
    }, { grouped: [], left: 0 - threshold }).grouped
}

const addDateLabels = (records, colors) => {
  return records.reduce((acc, record) => {
    if (getDate(record).getTime() !== acc.date?.getTime()) {
      acc.date = getDate(record)
      acc.newRecords.push({ label: (new Date(acc.date)).toLocaleDateString(), color: colors.textSecondary, divider: true }, record)
    } else {
      acc.newRecords.push(record)
    }
    return acc
  }, { newRecords:[], date: undefined }).newRecords
}

export default function GraphTooltipBubble({
  width,
  height,
  tooltip,
  xScale,
  margin = {top: 0, left: 0, bottom: 0, right: 0},
  axisDate = true,
  tooltipBounds = true,
}) {
  const { colors } = usePaletteTheme()
  const { tooltipData, tooltipLeft } = tooltip

  const bubbleTooltipStyles = {
    ...defaultStyles,
    background: `${colors.dark1}`,
    padding: "8px",
    lineHeight: '1.5',
    border: `1px solid ${colors.dark4}`,
    transitionDuration: '300ms',
    transitionDelay: '100ms',
    zIndex: 1301, //material ui zindex 1031
  }
    
  const { TooltipInPortal } = useTooltipInPortal({
    scroll: true,
    detectBounds: false,
  })
  const TooltipComponent = tooltipBounds ? TooltipWithBounds : TooltipInPortal

  const groupedTooltips = groupTooltipRecords(tooltipData, tooltipThreshold)

  return (
      <>
      {
        tooltipData && axisDate && (
        <Tooltip
          top={height - 3}
          left={tooltipLeft - 8}
          style={bottomTooltipStyles}
        >
          {xScale.invert(tooltipLeft - margin.left).toLocaleDateString()}
        </Tooltip>
        )
      }
      { groupedTooltips?.map((tooltip,i) => {
        const tooltipRelative = tooltip[0].left > width - tooltipThreshold ? 0 : tooltip.length - 1
        return (
        <TooltipComponent
          key={`tooltip-${i}`}
          top={tooltipBounds ? tooltip[tooltipRelative]?.top : tooltip[0]?.topClient }
          left={tooltipBounds ? tooltip[tooltipRelative]?.left : tooltip[0]?.leftClient}
          style={bubbleTooltipStyles}
          offsetLeft={16}
          offsetTop={-20}
        >
          { addDateLabels(tooltip, colors)?.map((record, i) => (
            <div key={`${record.label}-${i}-bubble-value`}>
              { record.divider && i !== 0 && (
                <div className={styles['divider']}><Divider/></div>
              )}
              <div className={styles['flex-between']} style={{color: record.color}}>
                <div className={styles['text-ellipsis']}> {record.label} </div>
                <div> {getValue(record)?.toLocaleString()} </div>
              </div>
            </div>
          )) }
        </TooltipComponent>
      )})
    }
  </>
  )
}